import { ThemeName } from 'constants/themes';
import { shouldApplySelectedTheme } from 'helpers/dark-mode';
import { featureBranchURL } from 'helpers/regexp';

export function getThemeAvailableOnCurrentSection(theme: ThemeName): ThemeName.Dark | ThemeName.Light {
  const pathname = window.location.pathname.replace(featureBranchURL, '');

  return shouldApplySelectedTheme(pathname) ? theme : ThemeName.Light;
}
